import { createContext, useContext, useState } from "react";

const CookieContext = createContext();

export const CookieProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState(
    localStorage.getItem("cookieConsent") || null,
  );

  const [showBanner, setShowBanner] = useState(
    !localStorage.getItem("cookieConsent"),
  );

  const acceptCookie = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setCookieConsent("accepted");
    setShowBanner(false);
  };

  const declineCookie = () => {
    localStorage.setItem("cookieConsent", "declined");
    setCookieConsent("declined");
    setShowBanner(false);
  };

  return (
    <CookieContext.Provider
      value={{
        cookieConsent,
        acceptCookie,
        declineCookie,
        showBanner,
        setShowBanner,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};

export const useCookie = () => useContext(CookieContext);
